import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { isLoadingValidationSelector, validateToken, validationDataSelector } from 'src/store/auth';

import { ROUTE } from 'src/constants/routes';
import { Loader } from 'src/components';

export const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const isLoading = useSelector(isLoadingValidationSelector);
  const validationData = useSelector(validationDataSelector);

  useEffect(() => {
    if (token && !validationData?.status && !isLoading) {
      dispatch(validateToken());
    }
  }, [dispatch, isLoading, token, validationData]);

  const shouldWaitForValidation = Boolean(token) && (isLoading || !validationData?.status);

  const divStyles = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return shouldWaitForValidation ? (
    <div style={divStyles}>
      <Loader />
    </div>
  ) : !token ? (
    <Navigate to={ROUTE.MAIN} />
  ) : (
    <Outlet />
  );
};
